import React from 'react';

interface DashboardLayoutProps {
  children: React.ReactNode;
}

/**
 * Centralized layout wrapper for all dashboard pages
 * Provides consistent max-width and padding across the application
 */
const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children }) => {
  return (
    <div className="max-w-[1600px] mx-auto px-2 py-6">
      {children}
    </div>
  );
};

export default DashboardLayout;

